/**
 * Palette tokens mapped to Snowflake Stellar color scales.
 * Same step keys as before — values only.
 */

export const green = {
  50: '#a0e9cd',
  100: '#b0e5d1',
  200: '#b0e5d1',
  300: '#a0e9cd',
  400: '#51d9ae',
  500: '#51caa5',
  600: '#51caa5',
  700: '#51caa5',
  800: '#51caa5',
  900: '#51caa5',
  950: '#51caa5'
} as const;

export const red = {
  50: '#ffced0',
  100: '#fccfcc',
  200: '#ffced0',
  300: '#ffced0',
  400: '#ef405e',
  500: '#d3132f',
  600: '#d3132f',
  700: '#d3132f',
  800: '#d3132f',
  900: '#d3132f',
  950: '#d3132f'
} as const;

export const amber = {
  50: '#fad67b',
  100: '#f5d791',
  200: '#fad67b',
  300: '#fad67b',
  400: '#f8c52a',
  500: '#ecb700',
  600: '#ecb700',
  700: '#ecb700',
  800: '#ecb700',
  900: '#ecb700',
  950: '#ecb700'
} as const;

export const neutral = {
  50: '#fbfbfb',
  100: '#f7f7f7',
  200: '#eceef1',
  300: '#dee3ea',
  400: '#d5dae4',
  500: '#bdc4d5',
  600: '#5d6a85',
  700: '#191e24',
  750: '#0f161e',
  800: '#0f161e',
  850: '#0f161e',
  900: '#0f161e',
  950: '#0f161e',
  white: '#ffffff'
} as const;

export const blue = {
  50: '#c5dcff',
  100: '#c6dbfd',
  200: '#c6dbfd',
  300: '#c5dcff',
  400: '#3580f2',
  500: '#1a6ce7',
  600: '#1a6ce7',
  700: '#1a6ce7',
  800: '#1a6ce7',
  900: '#1a6ce7',
  950: '#1a6ce7'
} as const;
